import { switchMap, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import Actions from '../actions'
import { catchAndDispatchError, getPayload } from '../utils/rxUtils'
import { getJSON, postPDF, getPDF } from '../utils/fetchUtils'
import { downloadFile } from '../utils/fileUtils'
import { catchAndDispatchCustomError } from '../utils/customErrorHandler'

export const getNHBillingAndPayments = action$ => {
  return action$.pipe(
    getPayload(Actions.NH_PAYMENTS_INFO_REQUESTED),
    switchMap(({ patientId }) => {
      return getJSON(`/get-member-billing/${patientId}`).pipe(
        switchMap(({ member_billing_details, autopay_indicator }) => {
          return of(
            Actions.createAction(Actions.NH_PAYMENTS_INFO_RECEIVED, {
              member_billing_details,
              autopay_indicator
            })
          )
        }),
        catchAndDispatchError
      )
    })
  )
}

export const getNHMemberInvoice = action$ => {
  return action$.pipe(
    getPayload(Actions.NH_PAYMENT_INVOICE_REQUESTED),
    switchMap(({ invoiceId }) => {
      return getJSON(`/get-member-invoice/${invoiceId}`).pipe(
        switchMap(({ result }) => {
          downloadFile(result, `invoice-${invoiceId}.pdf`)
          return of(Actions.createAction(Actions.NH_PAYMENT_INVOICE_RECEIVED))
        }),
        catchAndDispatchError
      )
    })
  )
}

export const getMemberEob = action$ => {
  return action$.pipe(
    getPayload(Actions.MEMBER_EOB_REQUESTED),
    switchMap(({ claimId, memberId }) => {
      return getPDF(`/get-eob-file/${claimId}/${memberId}`).pipe(
        switchMap(response => {
          // Create a Blob from the binary data and open it in new tab
          const blob = response
          return of(
            Actions.createAction(Actions.MEMBER_EOB_RECEIVED, {
              pdfBlob: blob
            })
          )
        }),
        catchError(() => {
          return of(Actions.createAction(Actions.MEMBER_EOB_FAILED))
        })
      )
    })
  )
}

export const getNHMemberSSODetails = action$ => {
  return action$.pipe(
    getPayload(Actions.NH_SSO_INFO_REQUESTED),
    switchMap(({ patientId }) => {
      return getJSON(`/get-member-sso-details/${patientId}`).pipe(
        switchMap(result => {
          return of(Actions.createAction(Actions.NH_SSO_INFO_RECEIVED, result))
        }),
        catchAndDispatchError
      )
    })
  )
}

export const getNHMemberIdCard = action$ => {
  return action$.pipe(
    getPayload(Actions.MEMBER_CARD_REQUESTED),
    switchMap(({ patientId }) => {
      return postPDF(`/get-id-card-files/${patientId}`).pipe(
        switchMap(result => {
          return of(Actions.createAction(Actions.MEMBER_CARD_RECEIVED, result))
        }),
        catchError(() => {
          return of(Actions.createAction(Actions.MEMBER_CARD_FAILED))
        })
      )
    })
  )
}

export const memberPlanDetails = action$ =>
  action$.pipe(
    getPayload(Actions.MEMBER_PLAN_DETAILS_REQUESTED),
    switchMap(() => {
      return getJSON('/zuora/hmo-plan-details/').pipe(
        switchMap(result => {
          return of(
            Actions.createAction(Actions.MEMBER_PLAN_DETAILS_RECEIVED, result)
          )
        }),
        catchAndDispatchCustomError
      )
    })
  )

export const getClaims = action$ =>
  action$.pipe(
    getPayload(Actions.CLAIMS_REQUESTED),
    switchMap(() => {
      return getJSON(`/get-member-claims/`).pipe(
        switchMap(result => {
          return of(Actions.createAction(Actions.CLAIMS_RECEIVED, result))
        }),
        catchError(() => {
          return of(Actions.createAction(Actions.CLAIMS_FAILED))
        })
      )
    })
  )

export const getClaimDetails = action$ =>
  action$.pipe(
    getPayload(Actions.CLAIM_DETAILS_REQUESTED),
    switchMap(({ claimId, memberId }) => {
      return getJSON(`/get-member-claim/${claimId}/${memberId}`).pipe(
        switchMap(result => {
          return of(
            Actions.createAction(Actions.CLAIM_DETAILS_RECEIVED, result)
          )
        }),
        catchError(() => {
          return of(Actions.createAction(Actions.CLAIM_DETAILS_FAILED))
        })
      )
    })
  )
